/**
 * VeeValidateによるバリデーション定義
 */
import Vue from 'vue';
import { ValidationProvider, ValidationObserver, extend, localize } from 'vee-validate';
import ja from 'vee-validate/dist/locale/ja.json';
import { required, email, numeric, max, min_value as minValue, max_value as maxValue } from 'vee-validate/dist/rules';

extend('required', required);
extend('email', email);
extend('numeric', numeric);
extend('max', {
  ...max,
  message: '{length} 文字以内で入力してください'
});
extend('min_value', {
  ...minValue,
  message: '{min} 以上の値で入力してください'
});
extend('max_value', {
  ...maxValue,
  message: '{max} 以下の値で入力してください'
});

/**
 * アップロードファイルサイズチェック
 * 初期値はtrueを返却
 */
extend('fileMaxSize', {
  ...required,
  validate(value: File | File[], params: any) {

    const maxmum = Number(Object.values(params)[0]);
    if (!Number.isInteger(maxmum)) return true;

    const errMessage = 'ファイルサイズを確認してください ';

    const checkSize = (name: string, size: number, max: number): string | null => {
      return size >= maxmum ? name : null;
    };

    if (Array.isArray(value)){
      const ngFileNames: string[] = [];
      for (const i in value) {
        const check = checkSize(value[i].name, value[i].size, maxmum);
        if (check !== null) ngFileNames.push(check);
      }
      return ngFileNames.length === 0 ? true : `${errMessage}(${ngFileNames.join('、')})` ;
    }

    const check = checkSize(value.name, value.size, maxmum);
    return check === null ? true : `${errMessage}(${check})` ;

  }
});

/**
 * アップロードファイル数チェック
 * 初期値はtrueを返却
 * paramsには現状アップ数を動的差し引いた数を付与
 */
 extend('fileMaxCount', {
  ...required,
  validate(value: File | File[], params: any) {

    const upLoadLimit = Number(Object.values(params)[0]);
    if (!Number.isInteger(upLoadLimit)) return true;

    const errMessage = `アップロード可能ファイル数の上限を超えています(${upLoadLimit}まで選択可能)` ;

    const upLoadFileList: File[] = Array.isArray(value) ? [...value] : [value] ;
    return upLoadFileList.length > upLoadLimit ? errMessage : true ;

  }
});

localize('ja', ja);

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
